import { initializeApp, FirebaseApp } from 'firebase/app';

export interface FirebaseConfig {
  apiKey: string;
  authDomain?: string;
  projectId: string;
  storageBucket?: string;
  messagingSenderId?: string;
  appId: string;
  measurementId?: string;
}

let firebaseApp: FirebaseApp | null = null;

/**
 * Inicializa o Firebase App
 * @param config - Configuração do Firebase
 * @returns FirebaseApp instance ou null se houver erro
 */
export const initializeFirebaseApp = (config: FirebaseConfig): FirebaseApp | null => {
  if (firebaseApp) {
    return firebaseApp;
  }

  const requiredFields: (keyof FirebaseConfig)[] = ['apiKey', 'projectId', 'appId'];
  const missingFields = requiredFields.filter(field => !config[field]);

  if (missingFields.length > 0) {
    console.warn(`[FIREBASE] Missing required fields: ${missingFields.join(', ')}`);
    console.warn('[FIREBASE] Firebase features will be disabled');
    return null;
  }

  try {
    firebaseApp = initializeApp(config);
    console.log('[FIREBASE] App initialized successfully');
    return firebaseApp;
  } catch (error) {
    console.error('[FIREBASE] Failed to initialize:', error);
    return null;
  }
};

/**
 * Retorna a instância atual do Firebase App
 * @returns FirebaseApp instance ou null se não inicializado
 */
export const getFirebaseApp = (): FirebaseApp | null => {
  return firebaseApp;
};

/**
 * Verifica se o Firebase está habilitado e inicializado
 * @returns true se Firebase está disponível
 */
export const isFirebaseEnabled = (): boolean => {
  return firebaseApp !== null;
};

/**
 * Reinicia o Firebase (útil para testes ou reconfiguração)
 */
export const resetFirebase = (): void => {
  firebaseApp = null;
};
